import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function CheckListSection({ element }) {
  return (
    <Container fluid>
      <Row>
        <Col className="">
          <Row className="flex-column justify-content-between h-100">
            <Col>
              <h2 data-aos="fade-up">{element.title}</h2>
            </Col>
            <Col
              lg={10}
              xl={8}
              className="layout_mt_new d-flex flex-column justify-content-end"
            >
              <p
                data-aos="fade-up"
                className="layout_text"
                dangerouslySetInnerHTML={{ __html: element.description }}
              ></p>
            </Col>
          </Row>
        </Col>
        <Col
          xs={12}
          sm={11}
          lg={6}
          xl={5}
          xxl={5}
          className="d-flex flex-column gap-3 layout_mt_new mt-lg-0"
        >
          {element.items?.map((item, index) => {
            return (
              <div
                key={index}
                data-aos="fade-up"
                className="layout_text d-flex gap-3 align-items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  className="flex-shrink-0"
                >
                  <circle cx="16" cy="16" r="16" fill="#d1eaff" />
                  <path
                    d="M8 17L12 21L23 10"
                    stroke="#d1eaff"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8 17L12 21L23 10"
                    stroke="#00539c"
                    strokeWidth="2.66667"
                    strokeLinecap="round"
                  />
                </svg>
                <p>{item.text}</p>
              </div>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
}
